module.exports = __webpack_public_path__ + "img/success.a15d6b3b.svg";